import * as CryptoJS from 'crypto-js';

export function hashString(password:string):string {
    return CryptoJS.SHA1(password).toString(CryptoJS.enc.Hex);
}